import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is Pa = kg/ms2

export const Pressure: BaseQuantity = {
  id: "001pressure",
  name: "pressure",
  type: "numeric",
  value: "",
  symbol: "p",
  baseUnit: "Pa",
  selectedUnit: "Pa",
  units: [
    { name: "Pa", fromConst: 1, toConst: 1 },
    { name: "kPa", fromConst: 1000, toConst: 1 / 1000 },
    { name: "bar", fromConst: 100000, toConst: 1 / 100000 },
    { name: "MPa", fromConst: 10 ** 6, toConst: 1 / 10 ** 6 },
    { name: "GPa", fromConst: 10 ** 9, toConst: 1 / 10 ** 9 },
    { name: "psi", fromConst: 6894.76, toConst: 1 / 6894.76 },
    { name: "atm", fromConst: 101325, toConst: 1 / 101325 },
    { name: "torr", fromConst: 133.3224, toConst: 1 / 133.3224 },
  ],
};
